<template>
  <div class="admin-page admin-inquiry">
    <h1>문의 관리</h1>      

    <vhp-table 
      :headers="headers"
      :items="InsquiryList"
    >
      <!-- 상세보기 아이콘 -->
      <template #item-edit="{ item }">
        <img
          @click="openDetail(item)"
          src="@/assets/image/edit.svg"
          height="15"
          class="pointer"
        />
      </template>

      <!-- 첨부파일 다운로드 -->
      <template #item-attachment="{ item }">
        <div v-if="item.attachment?.url">
          <a
            target="_blank"
            :href="item.attachment.url"
            :download="item.attachment.filename"
          >
            다운로드
            <img src="@/assets/image/download.svg" height="18" />
          </a>
        </div>
        <div v-else>-</div>
      </template>
    </vhp-table>

    <!-- 상세 보기 Dialog -->
    <vhp-dialog
      title="문의 내용"
      id="inquiry-detail"
      ref="detail"
      width="370"
      height="400"
    >
      <template #content>
        <div class="inquiry-detail">
          <p class="label">연락처</p>
          <p class="value">{{ detailItem.phoneNumber }}</p>

          <p class="label">이메일</p>
          <p class="value">{{ detailItem.email }}</p>

          <div class="divider"></div>

          <p class="content">{{ detailItem.content }}</p>

          <div v-if="detailItem.attachmentName" class="attachment-area">
            <div class="divider"></div>
            <p class="label">첨부파일</p>
            <a
              :href="detailItem.attachmentName"
              target="_blank"
              class="download-link"
            >
              다운로드하기
              <img src="@/assets/image/download.svg" height="18" />
            </a>
          </div>
        </div>
      </template>
    </vhp-dialog>


  </div>
</template>

<script>
export default {
  name: 'InquiryLog',
  data() {
    return {
      // 테이블 헤더
      headers: [
        { text: '회사명', value: 'companyName' },
        { text: '이름', value: 'name' },
        { text: '문의유형', value: 'contactType' },
        { text: '날짜', value: 'createdDate' },
        { text: '상세보기', value: 'edit', sortable: false },
      ],
      // 데이터
      InsquiryList: [],
      detailItem: {},
    };
  },

  created() {
    this.getInquiryList();   // 화면 로드시 자동 호출
  },

  methods: {
    // ✅ DB에서 목록 받아오기
    async getInquiryList() {
      try {
        const res = await this.$axios.get("/inquiry"); //console.log(res.data);
        this.InsquiryList = res.data;   // ✅ 테이블에 바로 넣기

      } catch (err) {
        console.error(err);
      }
    },

    // ✅ 상세보기 열기
    openDetail(item) {
    this.detailItem = item;   // ✅ 클릭한 항목의 전체 데이터 저장
    this.$refs.detail.load(); // Dialog 열기
  },
  },
};
</script>

<style lang="scss" src="./inquiry.scss"></style>
